export const up = (pageContent) => {
    const hasPageColor = Object.keys(pageContent).includes('pageColor');
    if (!hasPageColor) {
        pageContent.pageColor = {
            rgb: 'rgb(255, 255, 255)',
            hex: 'FFFFFF',
            X: 0,
            Y: 150
        };
    }

    // const hasPageRadius = Object.keys(pageContent).includes('pageRadius');
    // if (!hasPageRadius) {
    //     pageContent.pageRadius = 0;
    // }

    // const hasLockedValue = Object.keys(pageContent).includes('isLocked');
    // if (!hasLockedValue) {
    //     pageContent.isLocked = false;
    // }

    return pageContent;
}